var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreadcrumpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15134 13.2432C7.94955 13.0154 7.94955 12.6461 8.15134 12.4183L12.9547 6.99739L8.15134 1.57659C7.94955 1.34874 7.94955 0.979378 8.15134 0.751528C8.35324 0.523795 8.68052 0.523795 8.88242 0.751528L14.4167 6.99739L8.88242 13.2432C8.68052 13.471 8.35324 13.471 8.15134 13.2432Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.837088 13.2432C0.606387 13.0154 0.606387 12.6461 0.837088 12.4183L6.3266 6.99739L0.837088 1.57659C0.606387 1.34874 0.606387 0.979378 0.837088 0.751528C1.06778 0.523795 1.4418 0.523795 1.67249 0.751528L7.9974 6.99739L1.67249 13.2432C1.4418 13.471 1.06778 13.471 0.837088 13.2432Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumpArrow);
export default __webpack_public_path__ + "static/media/breadcrumpArrow.e422ce0dcb24d65e8b0ffb0276471891.svg";
export { ForwardRef as ReactComponent };